import React, { Component } from "react";
import axios from "axios";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';


const QuillModules = {
    toolbar: [
        // Headers, lists, and text styles
        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],

        // Alignment, links, and media
        [{ 'align': [] }],
        ['link', 'image', 'video'],

        // Cleanup and code
        ['clean'],
        ['code-block']
    ],
};

// Configuration for formats to be allowed (important for copy/paste from Word/HTML)
const QuillFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'align', 'code-block'
];

class TutorBlogEdit extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        students: [],
        isContactVisible: false,
        blog: {
            id: null,
            title: "",
            narration: "",
            label: "",
            image: null,
            // 💡 The description will now store the HTML string from ReactQuill
            description: "",
            tags: [],
            tagInput: ""
        },
        loading: false,
        error: null
    }
    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        } 
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        // this.fetchStudents();

        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                if (user && user.role === 'student') {
                    window.location.href = '/dashboard';
                }
            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
            }
        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('accessToken');
            window.location.href = '/login';
        }

        const storedBlogPost = localStorage.getItem('GeoacademyBlogPost');
        if (storedBlogPost) {
            try {
                const blogPost = JSON.parse(storedBlogPost);
                this.setState({
                    blog: {
                        ...blogPost,
                        id: blogPost.id || null,
                        tags: blogPost.tags || [],
                        tagInput: ""
                    }
                });
                localStorage.removeItem('GeoacademyBlogPost');
            } catch (error) {
                console.error("Error parsing blog post data:", error);
                localStorage.removeItem('GeoacademyBlogPost');
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };

    fetchStudents = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/all-students/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ students: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/";
            } else {
                console.error("Error fetching data:", error);
            }
        }
    };





    // 2. Handler for all standard text inputs, textareas, and selects
    handleInput = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => {
            let updatedBlog = { ...prevState.blog, [name]: value };

            // If typing title, also update seo_title
            if (name === "title") {
                updatedBlog.seo_title = value;
            }
            // If typing narration, also update seo_description
            if (name === "narration") {
                updatedBlog.seo_description = value;
            }

            return { blog: updatedBlog };
        });
    };
    // 💡 NEW: Handler specifically for the ReactQuill (Rich Text) editor
    handleDescriptionChange = (content, delta, source, editor) => {
        // 'content' is the HTML string value of the editor
        this.setState((prevState) => ({
            blog: {
                ...prevState.blog,
                description: content
            }
        }));
    };

    // 3. Handler specifically for the file input
    handleFileChange = (event) => {
        const file = event.target.files[0];

        this.setState((prevState) => ({
            blog: {
                ...prevState.blog,
                image: file // Store the actual File object here
            }
        }));
    };

    // ... (4, 5, 6, 7 are unchanged)
    // 4. Handler specifically for the Tag input field
    // handleTagInput = (event) => {
    //     const { value } = event.target;
    //     this.setState((prevState) => ({
    //         blog: {
    //             ...prevState.blog,
    //             tagInput: value
    //         }
    //     }));
    // };
    handleTagInput = (event) => {
        const { value } = event.target;

        // Check if the input contains at least one comma
        if (value.includes(",")) {
            // 1. Split the string by commas
            const potentialTags = value.split(",");

            // 2. The last element in the array is what the user is currently typing 
            // (if it doesn't end with a comma). 
            // Everything before the last comma is a completed tag.
            const newTagsToAdd = potentialTags
                .slice(0, -1) // Take everything except the last part
                .map(tag => tag.trim()) // Remove whitespace
                .filter(tag => tag !== "" && !this.state.blog.tags.includes(tag)); // Remove empty or duplicates

            const remainingInput = potentialTags[potentialTags.length - 1];

            if (newTagsToAdd.length > 0) {
                this.setState((prevState) => ({
                    blog: {
                        ...prevState.blog,
                        tags: [...prevState.blog.tags, ...newTagsToAdd],
                        tagInput: remainingInput // Keep the unfinished part in the input
                    }
                }));
            } else {
                // If no new unique tags were found, just update the input text
                this.setState((prevState) => ({
                    blog: { ...prevState.blog, tagInput: value }
                }));
            }
        } else {
            // Normal typing (no comma yet)
            this.setState((prevState) => ({
                blog: {
                    ...prevState.blog,
                    tagInput: value
                }
            }));
        }
    };

    handleKeyDown = (event) => {
        // Add tag on Enter or Tab
        if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            const value = this.state.blog.tagInput.trim();

            if (value && !this.state.blog.tags.includes(value)) {
                this.setState((prevState) => ({
                    blog: {
                        ...prevState.blog,
                        tags: [...prevState.blog.tags, value],
                        tagInput: ""
                    }
                }));
            }
        }
    };

    // 5. Handler for the "Add Tag" button
    handleAddTag = () => {
        const { blog } = this.state;
        const newTag = blog.tagInput.trim();

        if (newTag && !blog.tags.includes(newTag)) {
            this.setState((prevState) => ({
                blog: {
                    ...prevState.blog,
                    tags: [...prevState.blog.tags, newTag],
                    tagInput: "" // Clear the input field
                }
            }));
        }
    };

    // 6. Handler for removing a tag button
    handleRemoveTag = (tagToRemove) => {
        this.setState((prevState) => ({
            blog: {
                ...prevState.blog,
                tags: prevState.blog.tags.filter(tag => tag !== tagToRemove),
            }
        }));
    };

    // 7. ✅ Corrected handleSubmit function
    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({ loading: true, error: null });

        const accessToken = localStorage.getItem("accessToken");
        const blogNo = this.state.blog.id;

        const formData = new FormData();
        const { tagInput, tags, image, id, ...blogData } = this.state.blog;

        // Append all regular text/value fields (including the HTML string from 'description')
        Object.keys(blogData).forEach(key => {
            formData.append(key, blogData[key]);
        });

        if (image instanceof File) {
            formData.append('image', image);
        }

        formData.append('tags', JSON.stringify(tags));

        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };

        let response;

        try {
            if (blogNo) {
                response = await axios.patch(`https://api.geoinfoacademy.com/api/blogs/${blogNo}/`, formData, config);
            } else {
                response = await axios.post('https://api.geoinfoacademy.com/api/blogs/', formData, config);
            }

            console.log("Submission successful:", response.data);

            this.setState({
                blog: {
                    id: null,
                    title: "", narration: "", label: "",
                    image: null,
                    description: "", // Reset editor content
                    tags: [], tagInput: ""
                },
                loading: false
            });

        } catch (error) {
            console.error("Submission error:", error);

            // 1. Check for 401 (Unauthorized) or 403 (Forbidden)
            const status = error.response ? error.response.status : null;

            if (status === 401 || status === 403) {
                // Clear session data
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');

                // Redirect to login
                window.location.href = '/login';
                return; // Exit early so we don't set error states on a page we are leaving
            }

            // 2. Fallback logic for other errors
            let errorMessage = "Network error or server unavailable.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.detail || JSON.stringify(error.response.data);
            }

            this.setState({ error: errorMessage });

            setTimeout(() => {
                this.setState({ error: null });
            }, 5000);

        } finally {
            this.setState({ loading: false });
        }
    }


    render() {
        const { menuCoverWidth, students } = this.state;
        const { blog, loading, error } = this.state
        const { title, narration, label, image, description, tagInput, tags, seo_title, seo_description, slug } = blog;
        const blogNo = blog.id;
        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <TutorDashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`, overflow: 'hidden' }}>
                    <div className="blog_cover" >
                        <div className="blog_container edit" style={{ gap: "30px", margin: "50px 0px" }}>
                            <h2>{blogNo ? "Edit" : "Create"} & Publish, Your Content Command Center</h2>
                            <p>{error && <span style={{ color: 'red' }}>Error: {error}</span>} </p>
                            <form className="blog_edit" onSubmit={this.handleSubmit}>
                                <label>Title</label>
                                <input type="text" name="title" id="title" value={title || ''} onChange={this.handleInput} /><br />

                                <label>SEO Title</label>
                                <input type="text" name="seo_title" id="seo_title" value={seo_title || ''} onChange={this.handleInput} /><br />

                                <label> Naration</label>
                                <input type="text" name="narration" id="narration" value={narration || ''} onChange={this.handleInput} /><br />

                                <label>SEO Description</label>
                                <input type="text" name="seo_description" id="seo_description" value={seo_description || ''} onChange={this.handleInput} /><br />

                                <label>Label</label>
                                <select name="label" id="label" value={label || ''} onChange={this.handleInput} >
                                    <option value="">Select a label</option>
                                    <option value="GIS">GIS</option>
                                    <option value="Drone">Drone</option>
                                    <option value="Land Survey">Land Survey</option>
                                    <option value="Event">Event</option>
                                </select>
                                <br />

                                <label>Image (Upload File)</label>
                                {/* Display existing URL if editing and image is a string */}
                                {image && typeof image === 'string' &&
                                    <p><small>Current Image: **{image.substring(0, 50)}...** (New file upload will replace)</small></p>
                                }
                                <input
                                    type="file"
                                    name="image"
                                    id="image"
                                    onChange={this.handleFileChange}
                                />
                                <br />

                                {/* 💡 REPLACEMENT: Rich Text Editor (ReactQuill) */}
                                <label>Description</label>
                                <div className="text-editor-container">
                                    <ReactQuill
                                        theme="snow" // Uses the 'snow' theme (the one with the toolbar)
                                        value={description || ''} // Bound to state.blog.description (HTML string)
                                        onChange={this.handleDescriptionChange} // Uses the new handler
                                        modules={QuillModules} // Toolbar configuration
                                        formats={QuillFormats} // Allowed formats
                                        placeholder="Write your blog content here, including lists, bold text, images, and pasting from Word..."
                                    />
                                </div>
                                <br />

                                <label>Tag</label>
                                <div className="tag_input">
                                    <input
                                        type="text"
                                        name="tagInput"
                                        id="tag"
                                        value={tagInput || ''}
                                        onChange={this.handleTagInput}
                                        onKeyDown={this.handleKeyDown}
                                    />

                                    {/* <button
                                                        type="button"
                                                        onClick={this.handleAddTag}
                                                        disabled={!tagInput || tagInput.trim().length === 0}
                                                    >
                                                        Add Tag
                                                    </button> */}
                                </div><br />

                                <div className="tag_container">
                                    {tags.map((tag, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            onClick={() => this.handleRemoveTag(tag)}
                                            style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#f0f0f0', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer' }}
                                        >
                                            {tag} &nbsp; &times;
                                        </button>
                                    ))}
                                </div>


                                <label>Slug</label>
                                <input type="text" name="slug" id="slug" value={slug || ''} onChange={this.handleInput} /><br />



                                <div className="button">
                                    <button type="submit" disabled={loading}>
                                        {loading ? "Loading ... " : (blogNo ? "Update Post" : "Submit Post")}
                                    </button>
                                </div>
                            </form>
                            <p>{error && <span style={{ color: 'red' }}>Error: {error}</span>} </p>
                        </div>
                    </div>

                    <FooterDashboard />
                    <Policy />
                </div>
            </div>
        )
    }
}

export default TutorBlogEdit